import React, { ReactElement } from "react";
import { loadStripe, StripeElementLocale } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { getCurrencyCode, getSiteUrl, stripeKey } from "utils/site";
import { useWebTranslation } from "translations";
import Colors from "ui-kit/colors";

const stripePromise = loadStripe(stripeKey());

function StripeProvider({
  children,
  isPayout,
}: {
  children: ReactElement[] | ReactElement;
  isPayout?: boolean;
}): ReactElement {
  const { i18n } = useWebTranslation();

  return (
    <Elements
      stripe={stripePromise}
      options={{
        mode: "setup",
        currency: getCurrencyCode().toLowerCase(),
        setup_future_usage: "off_session",
        locale: i18n?.language as StripeElementLocale,
        payment_method_types: isPayout ? ["paypal"] : undefined,
        fonts: [
          {
            family: "Eina",
            style: "normal",
            weight: "normal",
            src: `url(${getSiteUrl()}/fonts/Eina01-Regular.woff)`,
          },
        ],
        appearance: {
          variables: {
            colorPrimary: Colors.blue300,
            colorText: "black",
            colorTextSecondary: Colors.grey500,
            colorTextPlaceholder: Colors.grey400,
            borderRadius: "10px",
            fontFamily: "Eina, sans-serif",
            fontSizeBase: "17px",
            fontSizeXs: "17px",
            spacingUnit: "4px",
          },
        },
      }}
    >
      {children}
    </Elements>
  );
}

export default StripeProvider;
